import { SsoProvider } from "@modules/sso";
import { message } from "antd";
import React from "react";
import { withTranslation } from "react-i18next";
import { Provider } from "react-redux";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import "./App.css";
import AdminLayout from "./components/layout/AdminLayout";
import AuthLayout from "./components/layout/AuthLayout";
import BasicLayout from "./components/layout/BasicLayout";
import NotFound from "./components/notFound";
import Admin from "./pages/Admin/Admin";
import Networks from "./pages/Admin/Networks/Networks";
import NetworksAdd from "./pages/Admin/Networks/NetworksAdd";
import NetworksEdit from "./pages/Admin/Networks/NetworksEdit";
import Users from "./pages/Admin/Users/Users";
import UsersEdit from "./pages/Admin/Users/UsersEdit";
import EndAccountByGuest from "./pages/EndAccount/endAccountByGuest";
import EndAccountBySponsor from "./pages/EndAccount/endAccountBySponsor";
import HealthCheck from "./pages/HealthCheck";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import RequestAccount from "./pages/RequestAccount";
import AccountSSO from "./pages/SSO/NewForms/newAccountSSO";
import EventSSO from "./pages/SSO/NewForms/newEventSSO";
import HomeSSO from "./pages/SSO/homeSSO";
import SSOConnect from "./pages/SSO/ssoConnect";
import ValidationPage from "./pages/ValidationPage";
import Welcome from "./pages/welcome";
import store from "./store/store";
import { getRedirect } from "./utils/functions";

function RouteWrapper({ component: Component, layout: Layout, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout {...props}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

const App = () => {
  store.subscribe(() => sessionStorage.setItem("access_token", store.getState().auth.token));

  message.config({
    top: 8,
    duration: 2,
    maxCount: 3,
  });

  return (
    <SsoProvider historyReplace={() => window.location.replace(getRedirect())}>
      <Provider store={store}>
        <Router>
          <div className="App">
            <div className="auth-wrapper">
              <Switch>
                <RouteWrapper path="/home-sso" layout={AuthLayout} component={HomeSSO} />
                <RouteWrapper path="/event-sso" layout={AuthLayout} component={EventSSO} />
                <RouteWrapper path="/account-sso" layout={AuthLayout} component={AccountSSO} />
                <RouteWrapper path="/confirm-account-sponsor/:id" layout={AuthLayout} component={EndAccountBySponsor} />
                <RouteWrapper layout={AdminLayout} exact path="/admin/admins/" component={Admin} />
                <RouteWrapper layout={AuthLayout} exact path="/admin/networks" component={Networks} />
                <RouteWrapper layout={AuthLayout} exact path="/admin/networks/edit/:id" component={NetworksEdit} />
                <RouteWrapper layout={AuthLayout} exact path="/admin/networks/add" component={NetworksAdd} />
                <RouteWrapper layout={AuthLayout} exact path="/admin/users" component={Users} />
                <RouteWrapper layout={AuthLayout} exact path="/admin/users/edit/:id" component={UsersEdit} />
                <RouteWrapper layout={BasicLayout} exact path="/" component={Login} />
                <RouteWrapper layout={BasicLayout} path="/sso-connect" component={SSOConnect} />
                <RouteWrapper layout={BasicLayout} exact path="/sso" component={SSOConnect} />
                <RouteWrapper layout={BasicLayout} path="/home" component={Login} />
                <RouteWrapper layout={BasicLayout} path="/request-account" component={RequestAccount} />
                <RouteWrapper layout={BasicLayout} path="/confirm-account-guest" component={EndAccountByGuest} />
                <RouteWrapper layout={BasicLayout} path="/welcome" component={Welcome} />
                <RouteWrapper layout={BasicLayout} path="/account-success" component={ValidationPage} />
                <RouteWrapper layout={BasicLayout} path="/health/health-check" component={HealthCheck} />
                <RouteWrapper layout={BasicLayout} path="/logout" component={Logout} />
                <RouteWrapper layout={BasicLayout} path="*" component={NotFound} />
              </Switch>
            </div>
          </div>
        </Router>
      </Provider>
    </SsoProvider>
  );
};

export default withTranslation()(App);
